  <template>
  <div class="right">
    <div class="mainTop">
      <div class="underHeader">
        <img src="../../assets/img/info.png" alt />
        当前位置：
      </div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
      >
        <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
        <el-breadcrumb-item>医药公司筛选</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 切换 -->
    <div class="rightTab">
      <div class="tab" :class="{active:nowIndex==0}" @click="titleTab(0)">可视化概览</div>
      <div class="tab" :class="{active:nowIndex==1}" @click="titleTab(1)">数据列表</div>
    </div>
    <!-- 可视化 -->
    <Visualization v-show="nowIndex===0"></Visualization>
    <!-- 数据列表 -->
    <div class="dataList" v-show="nowIndex===1">
      <!-- 查询 -->
      <div class="rightTop">
        <div class="title">
          <img src="@/assets/img/14.png" alt />
          <span>筛选条件</span>
        </div>
        <div class="addBox">
          <div class="con">
            <div class="conLeft">
              <div class="selectBox">
                <span>时间</span>
                <el-select
                  v-model="selectTime.value"
                  multiple
                  collapse-tags
                  placeholder="请选择"
                  @change="selectOne"
                >
                  <el-option
                    v-for="item in selectTime.timeList"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="selectBox">
                <span>商品大类</span>
                <el-select
                  v-model="selectType.value"
                  multiple
                  collapse-tags
                  placeholder="请选择"
                  @change="selectTwo"
                >
                  <el-option
                    v-for="item in selectType.typeList"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="selectBox last">
                <span>商品名称</span>
                <el-input placeholder="请输入商品名称" v-model="input" clearable @change="inputThree"></el-input>
              </div>
            </div>
          </div>
          <div class="searchBtn">
            <div class="button" @click="searchFun">查询</div>
          </div>
        </div>
      </div>
      <!--下载 -->
      <div class="rightCenter">
        <div class="centerTit">进出口金额</div>
        <div class="centerCon">
          <div class="no">
            <span></span>
          </div>
          <div class="cueWords" v-show="hint">最多下载1000条</div>

          <div class="excel" @click="downloadTable()" @mouseenter="enter()" @mouseleave="leave()">
            <img src="@/assets/img/Excel.png" alt />
            下载数据到Excel
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="rightBottom">
        <div class="tabulationBottom">
          <el-table :data="tableList" style="width: 100%" border size="mini">
            <af-table-column prop="time" fixed label="时间"></af-table-column>
            <af-table-column prop="type" fixed label="商品大类"></af-table-column>
            <af-table-column prop="productname" fixed label="商品名称"></af-table-column>
            <af-table-column prop="money" label="进出口额(万美元)"></af-table-column>
            <af-table-column prop="exmoney" label="出口金额(万美元)"></af-table-column>
            <af-table-column prop="immoney" label="进口金额(万美元)"></af-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <div class="rightPaging">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totlalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import api from "@/../static/common/api/api.js";
window.api = api;
// import "@/../plugins/echarts/china.js";
import axios from "axios";
import magic from "@/../static/common/magic.js";
import Visualization from "@/components/visualization.vue";

export default {
  props: {},
  components: {
    Visualization
  },
  data() {
    return {
      nowIndex: 1,
      // 表格
      types: "",
      times: "",
      productName: "",
      offset: 0, //从多少条开始
      limit: 10, //每页多少条
      totlalCount: 0, //总条数
      currentPage4: 1,

      // 选择框
      selectTime: {
        timeList: [],
        value: []
      },
      selectType: {
        typeList: [],
        value: []
      },
      input: "",
      tableList: [], //表格
      // 下载提示
      hint: false
    };
  },
  computed: {},
  methods: {
    // 切换
    titleTab(val) {
      this.nowIndex = val;
    },
    //查询
    selectOne(val) {
      this.times = val.toString();
      this.getTableData(
        this.types,
        this.times,
        this.productName,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    selectTwo(val) {
      this.types = val.toString();
      this.getTableData(
        this.types,
        this.times,
        this.productName,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    inputThree() {
      // console.log(this.input, 33333333333);
      this.productName = this.input;
      this.getTableData(
        this.types,
        this.times,
        this.productName,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    searchFun() {
      let _this = this;
      magic.loginOrRights(1).then(res => {
        // console.log(res, "bool");
        if (!res) {
          _this.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          _this.$message.error("请您购买！");
          return;
        }
        _this.getTableData(
          _this.types,
          _this.times,
          _this.productName,
          _this.offset,
          _this.limit
        );
        // 埋点
        try {
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
        } catch (e) {}
      });
    },
    // 获取时间
    getTime() {
      api.pharmaAmountTime().then(res => {
        this.selectTime.timeList = res.data;
      });
    },
    // 获取大类
    getType() {
      api.pharmaAmountType().then(res => {
        this.selectType.typeList = res.data;
      });
    },
    // 表格数据
    getTableData(types, times, productName, offset, limit) {
      let parmars = {
        types,
        times,
        productName,
        offset,
        limit
      };
      api.pharmaAmountTable(parmars).then(res => {
        // console.log(res.data, 7777777777777);
        this.tableList = res.data.rows;
        this.totlalCount = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.limit;
      this.getTableData(
        this.types,
        this.times,
        this.productName,
        this.offset,
        this.limit
      );
    },
    // 下载-
    enter() {
      this.hint = true;
    },
    leave() {
      this.hint = false;
    },
    downloadTable() {
      magic.loginOrRights(1).then(res => {
        if (!res) {
          this.$message.error("请您登录！");
        } else {
          api.weighterRights(1).then(res => {
            if (res.data) {
              axios({
                method: "post",
                url:
                  window.medicineUrl + "/medicineSearch/downImexportMoneyData", // 请求地址
                data: {
                  types: this.types,
                  times: this.times,
                  productName: this.productName,
                  offset: this.offset,
                  limit: this.limit
                },
                responseType: "arraybuffer",
                observe: "response"
              }).then(res => {
                const fileName = "进出口金额.xlsx";
                let blob = new Blob([res.data], {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const elink = document.createElement("a");
                  elink.download = fileName;
                  elink.style.display = "none";
                  elink.href = URL.createObjectURL(blob);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
              });
              // 埋点
              try {
                //LogCollection.contents["key"]="value";
                //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
                //2：收藏
                //3：下载
                //4：分享
                //5：购买
                //6：登录
                //7：注册
                //9：搜索
                //10：复制
                //11：点赞
                //12：评论
                LogCollection.send(3);
              } catch (e) {}
            } else {
              this.$message.error("请您购买！");
            }
          });
        }
      });
    },
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "excel.xlsx");

      document.body.appendChild(link);
      link.click();
    }
  },
  created() {},
  mounted() {
    this.getTime(); //时间
    this.getType(); //大类
    this.getTableData(
      //表格
      this.types,
      this.times,
      this.productName,
      this.offset,
      this.limit
    );
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/three.less";
</style>


// WEBPACK FOOTER //
// src/view/pharma/tradingSum.vue